import React from "react";
import axios from "axios";
import { baseUrl } from '../../config/clientsConfig'

const GLPagesService = {
  CreateGLPage: async (data) => {
    if (!data || Object.keys(data).length === 0) {
      throw new Error("No data provided to CreateGLPage.");
    }

    try {
      const response = await axios.post(`${baseUrl}/glpages/create`, data);
      return response.data;
    } catch (error) {
      console.error(
        "Error creating GL Page:",
        error.response?.data || error.message
      );
      throw error;
    }
  },
  UpdateGLPage: async (pageId, data) => {
    if (!pageId || Object.keys(data).length === 0) {
      throw new Error("No id or data provided to UpdateGLPage.");
    }
    try {
      const response = await axios.post(`${baseUrl}/glpages/update`, {
        pageId,
        ...data,
      });
      return response.data;
    } catch (error) {
      console.error(
        "Error updating GL Page:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  GetViewGLPages: async (nextId , direction = "next") => {
    try {
      const response = await axios.get(`${baseUrl}/glpages/get-all?next=${nextId}&direction=${direction}`);
      return response.data;
    } catch (error) {
      console.error(
        "Error fetching GL Pages:",
        error.response?.data || error.message
      );
      throw error;
    }
  },
  GetGLPageInfo: async (id) => {
    if (!id) {
      throw new Error("No id provided to GetGLPageInfo.");
    }
    try {
      const response = await axios.get(`${baseUrl}/glpages/get-info/${id}`);
      return response.data;
    } catch (error) {
      console.error(
        "Error fetching GL Page Info:",
        error.response?.data || error.message
      );
      throw error;
    }
  },
  UpdateGLPageStatus: async (id, status) => {
    if (!id || status == null || status == undefined) {
      throw new Error("No id or status provided to UpdateGLPageStatus.");
    }
    try {
      const response = await axios.post(`${baseUrl}/glpages/status-update`, {
        pageId: id,
        status,
      });
      return response.data;
    } catch (error) {
      console.error(
        "Error updating GL Page status:",
        error.response?.data || error.message
      );
      throw error;
    }
  },
  DeleteGLPageImage: async (imageUrl) => {

    let filePath = ""

    if(imageUrl.split("o/").length > 1){
      let lastpart = imageUrl.split("o/")[1]
      
filePath = decodeURIComponent(lastpart.split("?")[0]); 

}else if(imageUrl.split("app/").length > 1){
    let lastpart = imageUrl.split("app/")
      
filePath = lastpart[1];
}

    console.log(filePath)

    try {
      const response = await axios.delete(`${baseUrl}/glpages/delete-image`, {
        data: { imageUrl }
      });

      return response.data;
    } catch (error) {
      console.error(
        "Error deleting GL Page image:",
        error.response?.data || error.message
      );
      throw error;
    }
  },
  
  
  GetEnquiries: async (pageId) => {
    try {
      const response = await axios.get(
        `${baseUrl}/glpages/get-enquiries/${pageId}`
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error updating GL Page enquiries:",
        error.response?.data || error.message
      );
      throw error;
    }
  },
  getGLpageProperyName : async (type)=>{
    if(type=== "TopSelling")
    {
      return axios.get(`${baseUrl}/glpages/Properties`)
    }else{
      return axios.get(`${baseUrl}/glpages/Properties?type=${type}`)
    }
   
  },
  postLandGLPage : async (data) => {
    return axios.post(`${baseUrl}/glpages/landingPage`, data)
  },
  getLandingGLpage : async ()=>{
    return axios.get(`${baseUrl}/glpages/landingPageForm`)
  },
  updateLandingGLpage : async (data) =>{
    return axios.put(`${baseUrl}/glpages/landingPage`,data)
  },
  getPropertyOverViewData : async (propertyId , propertyTypeName) =>{
    return axios.get(`${baseUrl}/glpages/getPropertyOverViewPrePopulate?docId=${propertyId}&propertyTypeName=${propertyTypeName}`)
  }
};

export default GLPagesService;
